export const trackingEvents = {
  END_LONG_TERM_ASSIGNMENT: {
    SAVE: {
      CLICKED: 'end_long_term_assignment.save.clicked',
    },
  },
}
